module.exports = __webpack_public_path__ + "static/media/Draft.387e926b.svg";